import { cn } from "@synthesis/shared-utils";
import type { ReactNode } from "react";

type CreateApplicationFormSectionProps = {
  title: string;
  required?: boolean;
  children: ReactNode;
  className?: string;
};

export const CreateApplicationFormSection = ({ title, required, children, className }: CreateApplicationFormSectionProps) => (
  <section className={cn("flex flex-col gap-4", className)}>
    <h2 className="text-type-common heading-h4 text-2xl leading-8">
      {title}
      {required && <span className="text-system-error-50"> *</span>}
    </h2>
    {children}
  </section>
);

type CreateApplicationFormFieldProps = {
  label: ReactNode;
  required?: boolean;
  optionalHint?: string;
  hint?: string;
  children: ReactNode;
  className?: string;
};

export const CreateApplicationFormField = ({ label, required, optionalHint, hint, children, className }: CreateApplicationFormFieldProps) => (
  <div className={cn("flex flex-col gap-2", className)}>
    <span className="paragraph-sm text-type-common">
      {label}
      {required && <span className="text-system-error-50"> *</span>}
      {optionalHint && <span className="text-type-light"> {optionalHint}</span>}
    </span>
    {children}
    {hint && <span className="text-type-light text-[11px] leading-[18px]">{hint}</span>}
  </div>
);

type CreateApplicationFormRowProps = {
  children: ReactNode;
  className?: string;
};

export const CreateApplicationFormRow = ({ children, className }: CreateApplicationFormRowProps) => (
  <div className={cn("grid gap-4 lg:grid-cols-2", className)}>{children}</div>
);
